import React from "react";
import About from "./aboutUs/about";

const index = () => {
  return (
    <>
      <About />
    </>
  );
};

export default index;
